module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img1.4a3b6cbb.jpg";